module.exports = __webpack_public_path__ + "static/img/ebn.5b245fa9.png";